export default {
  data () {
    return {
      limit: 4
    }
  },
  computed: {
    limitedItem () {
      return []
    },
    limitReached () {
      return this.limitedItem.length >= this.limit
    }
  }
}
